import { useCallback, useMemo, useState } from 'react';

type Hook = (args: { pageSize?: number; dataLength: number }) => {
  page: number;
  nextPage: () => void;
  previousPage: () => void;
  totalPages: number;
};

export const usePagination: Hook = ({ pageSize = 100, dataLength }) => {
  const [page, setPage] = useState(0);

  const nextPage = useCallback(() => setPage((page) => page + 1), []);
  const previousPage = useCallback(() => setPage((page) => page - 1), []);

  const totalPages = useMemo(() => Math.ceil(dataLength / pageSize), [dataLength, pageSize]);

  return { page, nextPage, previousPage, totalPages };
};
